import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { AbortableFetchEventListener, Fetchable, FetchEventListener } from '@philips-emr/tws-core/lib/component/types';
import { isEqualShallow } from '@philips-emr/tws-utils';

import { HpmsCustomContentCollapseEventListener, PropCustom } from '../types';

export default class HpmsCustomContentCollapseApi extends ComponentAPI<PropCustom> implements Fetchable{

  /** @event */
  onAbort: FetchEventListener;

  /** @event */
  onAfterFetch: FetchEventListener;

  /** @event */
  onBeforeFetch: AbortableFetchEventListener;

  @AwesomeEvent
  onOpenCollapse = new HpmsCustomContentCollapseEventListener();

  public setEndpoint(endpoint: string): void {
    this.setState({ endpoint });
  }

  public getData(): Record<string, Value> {
    return this.state.data;
  }

  public setVisible(visible: boolean): void {
    this.setState({ visible });
  }

  public setParameters(parameters: Record<string, Value>): void {
    if (!isEqualShallow(this.state.parameters, parameters)) {
      this.setState({ parameters });
    }
  }

}
